import {
  LineSeries,
  SliceTooltipProps as NivoSliceTooltipProps,
} from '@nivo/line';
import * as React from 'react';
import Dot from '../../atoms/Dot';
import Text from '../../atoms/Text';
import Surface from '../../atoms/Surface';

import styles from './SliceTooltip.module.scss';

export type Props = NivoSliceTooltipProps<LineSeries>;

const Tooltip: React.FunctionComponent<Props> = ({ ...props }) => (
  <Surface backgroundColor="gray400" padding="sm">
    <div className={styles.wrapper}>
      {props.slice.points.map((point) => (
        <React.Fragment key={point.id}>
          <Dot color={point.color} />
          <Text size="sm2" color="white">
            {point.seriesId}
          </Text>
          <Text size="sm2" color="white">
            {point.data.yFormatted}
          </Text>
        </React.Fragment>
      ))}
    </div>
  </Surface>
);

export default Tooltip;
